import { withAppCrashIfException } from 'epic';
import { combineEpics } from 'redux-observable';

import { loadPreferenceStateEpic, persistPreferenceStateEpic } from './preferenceState/preferenceStateEpics';
import {
  acknowledgePriceImprovementsSelectionEpic,
  fetchColumnDefinitionEpic,
  loadFilters,
  persistFilters,
} from './priceImprovementBlotterEpics';

export const priceImprovementBlotterEpics = () =>
  withAppCrashIfException(
    'priceImprovementBlotter',
    combineEpics(
      fetchColumnDefinitionEpic(),
      loadFilters(),
      loadPreferenceStateEpic(),
      persistFilters(),
      persistPreferenceStateEpic(),
      acknowledgePriceImprovementsSelectionEpic(),
    ),
  );
